import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../../brand-settings.setup';

const parent: SetupPage = BrandSettings.pages.general;
const path = 'top-up';
const title = 'PAGE.BRAND_SETTINGS.GENERAL.TOP_UP.TITLE';
const res = ['actions', 'actions.editAutoInitiatedTopUp'];

export const BrandSettingsGeneralTopUpTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
